module.exports = __webpack_public_path__ + "static/pexels-7-08e3fbb90a93e29b2021640418639a5d.png";